module.exports = __webpack_public_path__ + "static/media/CanBeSeenBad.7f532586.png";